export default {
  sidebar: {
    items: 'Item',
    priceOffer: 'Price Offer',
    discountOffer: 'Discount Offer',
    itemServices: 'Billable Services',
    discountTrigger: 'Discount Trigger',
  },
};
